export const GET_PLAYER_CONTENT = 'GET_PLAYER_CONTENT';
export const GET_PLAYER_CONTENT_REQUEST = 'GET_PLAYER_CONTENT_REQUEST';
export const GET_PLAYER_CONTENT_SUCCESS = 'GET_PLAYER_CONTENT_SUCCESS';
export const GET_PLAYER_CONTENT_ERROR = 'GET_PLAYER_CONTENT_ERROR';

export const GET_PLAYER_CONTENT_LEGACY = 'GET_PLAYER_CONTENT_LEGACY';
export const GET_PLAYER_CONTENT_LEGACY_REQUEST = 'GET_PLAYER_CONTENT_LEGACY_REQUEST';
export const GET_PLAYER_CONTENT_LEGACY_SUCCESS = 'GET_PLAYER_CONTENT_LEGACY_SUCCESS';
export const GET_PLAYER_CONTENT_LEGACY_ERROR = 'GET_PLAYER_CONTENT_LEGACY_ERROR';
